export const comments = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20watermelon%20character%20avatar%20with%20big%20eyes%2C%20minimalist%20flat%20design%2C%20kawaii%20style%2C%20simple%20clean%20background%2C%20vibrant%20green%20and%20red%20colors&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "吃瓜不嫌事大",
    time: "3分钟前",
    content: "这个瓜我吃了三天了！每天都有新反转，比追剧还刺激，编剧都不敢这么写吧哈哈哈😂",
    likes: 1283,
    tag: "娱乐圈爆料",
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Cute%20watermelon%20slice%20mascot%20character%20avatar%2C%20simple%20vector%20style%2C%20playful%20expression%2C%20pink%20and%20green%20color%20palette%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "今日份瓜已送达",
    time: "15分钟前",
    content: "刚从微博过来，热搜又爆了！这次涉及的品牌方都开始删帖了，大家且看且珍惜🏃",
    likes: 956,
    tag: "今日热门瓜",
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Adorable%20melon%20emoji%20style%20avatar%20character%2C%20minimalist%20cartoon%2C%20smiling%20face%2C%20fresh%20green%20tones%2C%20simple%20white%20background&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "理性吃瓜群众",
    time: "28分钟前",
    content: "建议大家理性看待，有些料明显是团队在带节奏。不过该吃的瓜一个都不能少！坐等实锤🔨",
    likes: 2105,
    tag: "吃瓜速报",
  },
];

export const topics = [
  { id: 1, name: "顶流塌房", heat: "987万", trend: "up", icon: "ri-fire-line" },
  { id: 2, name: "网红翻车", heat: "856万", trend: "up", icon: "ri-alert-line" },
  { id: 3, name: "恋情曝光", heat: "743万", trend: "up", icon: "ri-heart-line" },
  { id: 4, name: "综艺名场面", heat: "678万", trend: "up", icon: "ri-tv-line" },
  { id: 5, name: "明星穿搭", heat: "521万", trend: "down", icon: "ri-t-shirt-line" },
  { id: 6, name: "剧组八卦", heat: "489万", trend: "up", icon: "ri-clapperboard-line" },
  { id: 7, name: "选秀内幕", heat: "432万", trend: "up", icon: "ri-mic-line" },
  { id: 8, name: "代言风波", heat: "398万", trend: "down", icon: "ri-bill-line" },
  { id: 9, name: "直播事故", heat: "365万", trend: "up", icon: "ri-live-line" },
  { id: 10, name: "私生饭事件", heat: "312万", trend: "up", icon: "ri-camera-line" },
];

export const updates = [
  {
    id: 1,
    time: "10:32",
    title: "某顶流深夜发文疑似回应近期争议，粉丝连夜控评",
    tag: "最新",
    tagColor: "primary",
  },
  {
    id: 2,
    time: "09:15",
    title: "知名网红直播带货翻车，品牌方紧急发声明切割",
    tag: "热点",
    tagColor: "accent",
  },
  {
    id: 3,
    time: "08:47",
    title: "热门综艺录制现场爆冲突，工作人员回应：正常流程",
    tag: "独家",
    tagColor: "primary",
  },
  {
    id: 4,
    time: "07:20",
    title: "某女星深夜与神秘男子同回小区，工作室暂未回应",
    tag: "爆料",
    tagColor: "secondary",
  },
  {
    id: 5,
    time: "06:05",
    title: "选秀节目出道组成员被曝与经纪人恋爱三年",
    tag: "内幕",
    tagColor: "accent",
  },
  {
    id: 6,
    time: "昨日 23:30",
    title: "两大流量明星互删社交关注，粉丝大战一触即发",
    tag: "热议",
    tagColor: "primary",
  },
  {
    id: 7,
    time: "昨日 21:18",
    title: "网传某剧组男女主因番位问题片场冷战三周",
    tag: "八卦",
    tagColor: "secondary",
  },
  {
    id: 8,
    time: "昨日 18:42",
    title: "知名导演新片选角名单意外流出，多位一线明星在列",
    tag: "独家",
    tagColor: "primary",
  },
  {
    id: 9,
    time: "昨日 15:10",
    title: "品牌代言人突然被换，知情人士透露背后另有隐情",
    tag: "爆料",
    tagColor: "secondary",
  },
];

export const ranking = [
  {
    rank: 1,
    title: "某顶流被曝私生活混乱，多位圈内人实锤爆料",
    heat: "1,289万",
    change: "up",
    icon: "ri-fire-line",
  },
  {
    rank: 2,
    title: "知名夫妻档综艺翻车现场，网友直呼太尴尬",
    heat: "1,102万",
    change: "up",
    icon: "ri-fire-line",
  },
  {
    rank: 3,
    title: "00后小花绯闻男友身份曝光，竟然是圈外富二代",
    heat: "967万",
    change: "new",
    icon: "ri-sparkling-line",
  },
  {
    rank: 4,
    title: "某大牌代言人评选内幕流出，暗箱操作引众怒",
    heat: "834万",
    change: "up",
    icon: "ri-arrow-up-line",
  },
  {
    rank: 5,
    title: "网红自曝整容全过程，前后对比照惊呆网友",
    heat: "756万",
    change: "down",
    icon: "ri-arrow-down-line",
  },
];

export const cards = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Entertainment%20gossip%20news%20theme%2C%20dramatic%20stage%20curtains%20with%20spotlight%2C%20red%20and%20gold%20color%20palette%2C%20theatrical%20atmosphere%2C%20mysterious%20vibe%2C%20editorial%20photography%20with%20soft%20dramatic%20lighting%2C%20minimalist%20background%20with%20warm%20tones&width=800&height=500&seq=card-01&orientation=landscape",
    tag: "深度吃瓜",
    title: "从练习生到顶流：一位偶像的五年沉浮录",
    desc: "五年时间，从默默无闻到全网皆知，他的每一步都踩在了舆论的风口浪尖上。本文为你还原一个真实的顶流之路。",
    time: "2小时前",
    views: "12.8万",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20drama%20theme%2C%20smartphone%20screen%20showing%20trending%20topics%2C%20warm%20orange%20and%20pink%20gradient%20background%2C%20modern%20clean%20aesthetic%2C%20editorial%20style%2C%20soft%20lighting&width=800&height=500&seq=card-02&orientation=landscape",
    tag: "网红真相",
    title: "百万粉丝网红背后的MCN暗战",
    desc: "你以为的独立创作，可能只是MCN精心设计的剧本。揭开头部网红背后的资本博弈与流量密码。",
    time: "4小时前",
    views: "9.6万",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Film%20set%20behind%20scenes%20gossip%20theme%2C%20movie%20clapperboard%20on%20wooden%20table%2C%20warm%20cinematic%20lighting%2C%20vintage%20film%20aesthetic%2C%20soft%20bokeh%20background%2C%20editorial%20photography%20style&width=800&height=500&seq=card-03&orientation=landscape",
    tag: "剧组八卦",
    title: "年度大制作剧组：你不知道的幕后故事",
    desc: "投资过亿的大制作背后，导演与主演之间的微妙关系、拍摄现场的意外状况，比正片还精彩。",
    time: "6小时前",
    views: "8.3万",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Fashion%20brand%20endorsement%20controversy%20theme%2C%20luxury%20brand%20bags%20on%20minimalist%20background%2C%20warm%20golden%20tones%2C%20elegant%20editorial%20style%2C%20soft%20shadows%2C%20premium%20product%20photography&width=800&height=500&seq=card-04&orientation=landscape",
    tag: "代言风波",
    title: "品牌代言人突然换人，隐藏的商业逻辑",
    desc: "一个代言人的更替背后，往往藏着品牌战略调整、竞品博弈以及艺人商业价值的重新评估。",
    time: "8小时前",
    views: "7.1万",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20behind%20scenes%20theme%2C%20stage%20microphone%20with%20colorful%20spotlights%2C%20dramatic%20lighting%2C%20warm%20red%20and%20amber%20tones%2C%20concert%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=card-05&orientation=landscape",
    tag: "选秀内幕",
    title: "选秀节目投票机制大揭秘",
    desc: "那些看似公平的观众投票，到底有多少水分？业内人士曝光选秀产业链背后的运作规则。",
    time: "10小时前",
    views: "6.4万",
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=Celebrity%20couple%20scandal%20theme%2C%20two%20silhouettes%20in%20warm%20window%20light%2C%20romantic%20mysterious%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20editorial%20photography%2C%20elegant%20composition&width=800&height=500&seq=card-06&orientation=landscape",
    tag: "恋情揭秘",
    title: "娱乐圈隐秘情侣图鉴：那些你以为不可能的组合",
    desc: "表面毫无交集的两位艺人，私下竟然已经交往两年？信息蛛丝马迹带你还原真相。",
    time: "12小时前",
    views: "11.2万",
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=Live%20streaming%20accident%20theme%2C%20smartphone%20on%20tripod%20with%20ring%20light%2C%20warm%20cozy%20room%20setting%2C%20soft%20ambient%20lighting%2C%20modern%20content%20creator%20aesthetic%2C%20editorial%20style&width=800&height=500&seq=card-07&orientation=landscape",
    tag: "直播事故",
    title: "直播翻车名场面盘点：笑到肚子疼的年度合集",
    desc: "从口误到设备故障，从意外入镜到惊天爆料，盘点了今年最让人哭笑不得的直播翻车瞬间。",
    time: "14小时前",
    views: "15.3万",
  },
];

export const faqs = [
  {
    id: 1,
    question: "51吃瓜网的内容来源可靠吗？",
    answer: "我们每日整理全网公开的娱乐资讯、社交媒体动态及主流媒体报道，所有内容均注明来源出处。51吃瓜致力于为吃瓜群众提供全网最新、最全的娱乐八卦速递，同时提醒大家理性吃瓜，不传谣不信谣。",
  },
  {
    id: 2,
    question: "吃瓜速报多久更新一次？",
    answer: "吃瓜速报采用实时更新机制，编辑团队7×24小时轮值监控全网热点。一旦有重大娱乐圈爆料或网红事件发生，15分钟内即可推送快讯，确保51吃瓜群众永远不会错过任何精彩内容。",
  },
  {
    id: 3,
    question: "如何区分真实爆料和谣言？",
    answer: "我们会对每条爆料进行初步核实：优先采纳多方信源交叉验证的内容、标注未证实信息的状态、对明显造谣内容不予采编。欢迎51吃瓜群众在评论区理性讨论，共同维护健康的吃瓜环境。",
  },
  {
    id: 4,
    question: "51吃瓜网有移动端APP吗？",
    answer: "有的！51吃瓜APP已上架各大应用商店，支持iOS和Android双平台。APP端提供更流畅的浏览体验、个性化话题推送和即时热点通知，随时随地享受吃瓜乐趣。",
  },
  {
    id: 5,
    question: "可以向51吃瓜投稿或爆料吗？",
    answer: "欢迎！我们设有专门的投稿爆料通道。如果您有独家娱乐圈内幕、网红真相或者今日热门瓜的线索，请通过联系我们页面提交。审核通过后将标注来源并给予相应激励。",
  },
  {
    id: 6,
    question: "为什么叫51吃瓜？有什么特殊含义吗？",
    answer: "51谐音'我要'，加上'吃瓜'代表群众围观八卦的乐趣——我要吃瓜！这个名字传达了51吃瓜群众对娱乐圈爆料和网红真相的无限热情，也体现了我们每日最新瓜速递的平台定位。",
  },
];

export const carouselItems = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=Dramatic%20red%20curtain%20stage%20with%20spotlight%2C%20theatrical%20atmosphere%2C%20warm%20golden%20lighting%2C%20mysterious%20elegant%20vibe%2C%20editorial%20photography%2C%20cinematic%20composition%2C%20rich%20textures&width=1200&height=600&seq=carousel-01&orientation=landscape",
    title: "2024娱乐圈年度大事件全景回顾",
    desc: "从年初的顶流塌房到年末的世纪复合，这一年吃瓜群众见证的每一个名场面。",
    tag: "年度专题",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Social%20media%20trending%20topics%20visualization%2C%20floating%20hashtags%20in%20warm%20orange%20and%20red%20tones%2C%20abstract%20digital%20art%2C%20modern%20minimalist%20design%2C%20clean%20gradient%20background%2C%20tech%20aesthetic&width=1200&height=600&seq=carousel-02&orientation=landscape",
    title: "网红生态大调查：流量背后的真实生活",
    desc: "深入探访多位百万粉丝网红，记录镜头之外不为人知的真实日常。",
    tag: "深度调查",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Movie%20award%20ceremony%20red%20carpet%20theme%2C%20elegant%20golden%20trophy%20on%20velvet%20background%2C%20warm%20luxurious%20lighting%2C%20glamorous%20atmosphere%2C%20editorial%20photography%2C%20premium%20aesthetic&width=1200&height=600&seq=carousel-03&orientation=landscape",
    title: "选秀十年：那些出道即巅峰的选手去哪了",
    desc: "回望十年选秀史，追踪历届选手的现状，有人依旧闪耀，有人早已转行。",
    tag: "历史回顾",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Celebrity%20couple%20relationship%20timeline%20theme%2C%20romantic%20warm%20ambient%20photography%2C%20soft%20golden%20hour%20light%2C%20elegant%20interior%20with%20flowers%2C%20editorial%20style%2C%20dreamy%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape",
    title: "娱乐圈情侣生存指南：公开还是不公开",
    desc: "分析近年公开恋情的明星情侣，揭秘恋情曝光对事业的双面影响。",
    tag: "专题分析",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Fashion%20brand%20collaboration%20and%20endorsement%20theme%2C%20luxury%20products%20on%20minimalist%20display%2C%20warm%20golden%20tones%2C%20premium%20editorial%20photography%2C%20elegant%20composition%2C%20soft%20shadows&width=1200&height=600&seq=carousel-05&orientation=landscape",
    title: "品牌代言人变迁史：从四大天王到虚拟偶像",
    desc: "品牌代言人的选择变迁，折射出娱乐产业和消费市场的深层变化。",
    tag: "行业观察",
  },
];

export const appInfo = {
  title: "51吃瓜APP",
  subtitle: "随时随地，吃瓜不等待",
  desc: "下载51吃瓜APP，第一时间获取全网最新娱乐圈爆料、网红真相和今日热门瓜。支持个性化话题订阅、实时热点推送和离线阅读，让吃瓜成为你的日常乐趣。",
  features: ["实时热点推送", "个性化话题订阅", "离线阅读模式", "夜间护眼模式", "评论互动社区"],
  image: "https://readdy.ai/api/search-image?query=Mobile%20app%20screen%20mockup%20showing%20entertainment%20news%20feed%2C%20modern%20UI%20design%2C%20warm%20orange%20and%20white%20color%20scheme%2C%20card-based%20layout%2C%20clean%20minimalist%20Chinese%20interface%2C%20smartphone%20frame&width=600&height=800&seq=app-screen&orientation=portrait",
};

export const mediaItems = [
  {
    id: 1,
    thumbnail: "https://readdy.ai/api/search-image?query=Talk%20show%20studio%20set%20with%20warm%20lighting%2C%20comfortable%20sofa%20and%20coffee%20table%2C%20relaxed%20vibe%2C%20entertainment%20news%20discussion%20theme%2C%20modern%20studio%20design%2C%20soft%20ambient%20light&width=640&height=360&seq=media-01&orientation=landscape",
    title: "吃瓜圆桌派：本周最劲爆的五个瓜",
    duration: "32:18",
    views: "8.6万",
    tag: "热门",
  },
  {
    id: 2,
    thumbnail: "https://readdy.ai/api/search-image?query=Podcast%20recording%20studio%20with%20microphone%20and%20headphones%2C%20warm%20cozy%20atmosphere%2C%20dim%20ambient%20lighting%2C%20professional%20audio%20equipment%2C%20modern%20clean%20setup%2C%20editorial%20photography&width=640&height=360&seq=media-02&orientation=landscape",
    title: "深度揭秘：MCN如何制造一个网红",
    duration: "45:52",
    views: "6.2万",
    tag: "深度",
  },
  {
    id: 3,
    thumbnail: "https://readdy.ai/api/search-image?query=Entertainment%20news%20anchor%20desk%20studio%20theme%2C%20professional%20newsroom%20setting%2C%20warm%20lighting%2C%20modern%20broadcast%20design%2C%20large%20screen%20display%2C%20clean%20editorial%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape",
    title: "每日瓜报：五分钟看完今日全部热点",
    duration: "05:00",
    views: "12.3万",
    tag: "速看",
  },
];

export const features = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "全网最快吃瓜速递",
    desc: "7×24小时全天候监控全网热点，娱乐圈爆料、网红翻车、明星八卦，15分钟内极速推送，让你永远比别人先吃到第一口瓜。",
  },
  {
    id: 2,
    icon: "ri-shield-check-line",
    title: "严格信息核实机制",
    desc: "每条爆料经过多方信源交叉验证，未证实信息明确标注，拒绝谣言传播。吃瓜不传谣，专业吃瓜从51开始。",
  },
  {
    id: 3,
    icon: "ri-group-line",
    title: "百万吃瓜群众聚集地",
    desc: "活跃的评论互动社区，理性讨论、欢乐吐槽，和志同道合的吃瓜群众一起分享今日热门瓜的每一个精彩瞬间。",
  },
  {
    id: 4,
    icon: "ri-smartphone-line",
    title: "多端同步无缝衔接",
    desc: "支持Web、iOS、Android多平台使用，账号云端同步，在家用电脑看深度分析，出门用手机刷吃瓜速报，体验不中断。",
  },
];

export const aboutInfo = {
  title: "关于51吃瓜",
  subtitle: "全网最懂你的吃瓜速递平台",
  desc: "51今日吃瓜成立于2020年，是国内领先的娱乐八卦聚合平台。我们专注于为吃瓜群众提供51吃瓜网今日吃瓜资源，涵盖51吃瓜官网全网最新资讯、娱乐圈爆料、网红真相、今日热门瓜等全方位内容。团队由资深娱乐编辑和数据分析师组成，通过智能算法与人工审核相结合的方式，确保每一条吃瓜速报的时效性和准确性。51吃瓜在线观看功能更让你随时随地享受吃瓜乐趣。截至目前，平台已累计服务超过千万吃瓜群众，日均更新内容超过200条。我们将继续努力，为51吃瓜群众提供每日最新瓜速递，让吃瓜成为一种快乐的生活方式。",
  stats: [
    { value: "1000万+", label: "累计用户" },
    { value: "200+", label: "日更新量" },
    { value: "99.7%", label: "信息准确率" },
    { value: "15min", label: "热点响应" },
  ],
};

export const contactInfo = {
  title: "投稿爆料",
  subtitle: "你有瓜？我们帮你分享给全世界",
  desc: "如果你有独家娱乐圈内幕、网红真相爆料或任何值得分享的今日热门瓜，欢迎通过以下方式联系我们。所有投稿将严格保护爆料人隐私，审核通过的内容将获得专属曝光位和相应激励。51吃瓜群众期待你的精彩分享！",
  email: "tougao@51chigua.com",
  wechat: "chigua51official",
};

export const indexItems = [
  {
    id: 1,
    name: "顶流明星专区",
    desc: "聚焦当下最热门流量明星的所有动态",
    count: "326篇",
    icon: "ri-star-line",
  },
  {
    id: 2,
    name: "网红达人追踪",
    desc: "头部网红、KOL的最新动态和幕后故事",
    count: "258篇",
    icon: "ri-user-smile-line",
  },
  {
    id: 3,
    name: "综艺节目八卦",
    desc: "热门综艺录制花絮、选手内幕全收录",
    count: "412篇",
    icon: "ri-tv-2-line",
  },
  {
    id: 4,
    name: "影视剧组探秘",
    desc: "电影电视剧拍摄现场的第一手爆料",
    count: "187篇",
    icon: "ri-film-line",
  },
  {
    id: 5,
    name: "品牌代言观察",
    desc: "明星代言更替、品牌选择背后的商业逻辑",
    count: "143篇",
    icon: "ri-shopping-bag-line",
  },
  {
    id: 6,
    name: "直播圈风云录",
    desc: "直播行业大事件、主播恩怨情仇全记录",
    count: "295篇",
    icon: "ri-live-line",
  },
  {
    id: 7,
    name: "音乐圈深水区",
    desc: "从选秀到发片，音乐产业不为人知的一面",
    count: "168篇",
    icon: "ri-music-line",
  },
  {
    id: 8,
    name: "时尚圈名利场",
    desc: "时尚活动、红毯造型、品牌合作内幕揭秘",
    count: "134篇",
    icon: "ri-vip-crown-line",
  },
];